import { render, staticRenderFns } from "./BusinessInfo.vue?vue&type=template&id=0045e80d"
import script from "./BusinessInfo.vue?vue&type=script&lang=ts"
export * from "./BusinessInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports